import React, { useEffect, useState } from 'react';
import './LandingPage.css';

const TAGLINES = [
  "The ruins of Phlan await.",
  "Evil stirs in the Moonsea.",
  "Will you answer the call?",
];

export default function LandingPage() {
  const [taglineIndex, setTaglineIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setTaglineIndex(i => (i + 1) % TAGLINES.length);
        setVisible(true);
      }, 600);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="landing">
      {/* Atmospheric background layers */}
      <div className="landing__bg" />
      <div className="landing__fog" />
      <div className="landing__vignette" />

      {/* Floating embers */}
      {[...Array(12)].map((_, i) => (
        <div key={i} className="ember" style={{
          left: `${Math.random() * 100}%`,
          animationDelay: `${Math.random() * 8}s`,
          animationDuration: `${6 + Math.random() * 6}s`,
        }} />
      ))}

      <main className="landing__content fade-in">
        {/* Top ornament */}
        <div className="landing__sigil">✦</div>

        {/* Title block */}
        <header className="landing__header">
          <p className="landing__eyebrow">Advanced Dungeons & Dragons · 5.5e</p>
          <h1 className="landing__title">
            <span className="landing__title-pool">Pool of</span>
            <span className="landing__title-radiance">Radiance</span>
          </h1>
          <div className="ornament landing__ornament">
            <span>Moonsea Chronicles</span>
          </div>
        </header>

        {/* Rotating tagline */}
        <p className={`landing__tagline ${visible ? 'tagline--visible' : 'tagline--hidden'}`}>
          {TAGLINES[taglineIndex]}
        </p>

        {/* Lore excerpt */}
        <div className="landing__lore panel">
          <p>
            The once-proud city of <em>Phlan</em> has fallen to darkness. Monsters
            prowl its ruins while the Council of New Phlan desperately seeks
            adventurers bold enough to reclaim the occupied city — district
            by district, sword by sword.
          </p>
          <p>
            Beyond the ruins, something ancient and malevolent stirs beneath
            the waters of the Moonsea. A presence that has not walked
            the world in a thousand years prepares to rise again.
          </p>
        </div>

        {/* CTA buttons */}
        <div className="landing__actions">
          <button
            className="btn btn-primary landing__cta"
            onClick={() => { window.location.href = 'https://play.zacparkercoaching.com/pool-of-radiance/index.html'; }}
          >
            Begin Your Quest
          </button>
          <button className="btn landing__cta-secondary">
            Continue Adventure
          </button>
        </div>

        {/* Footer note */}
        <footer className="landing__footer">
          <div className="ornament"><span>✦ ✦ ✦</span></div>
          <p>A faithful reimagining of the 1988 SSI classic · Powered by D&amp;D 5.5e rules</p>
        </footer>
      </main>
    </div>
  );
}